/*
 * Public API Surface of ngx-gallery
 */

export * from './lib/ngx-gallery.service';
export * from './lib/ngx-gallery.component';
export * from './lib/ngx-gallery.module';
export * from './lib/ngx-gallery-action';
export * from './lib/ngx-gallery-image';
export * from './lib/ngx-gallery-thumbnails/ngx-gallery-thumbnails.component';
export * from './lib/ngx-gallery-preview/ngx-gallery-preview.component';
export * from './lib/ngx-gallery-arrows/ngx-gallery-arrows.component';
export * from './lib/ngx-gallery-bullets/ngx-gallery-bullets.component';
export * from './lib/ngx-gallery-options';
export * from './lib/ngx-gallery-image';
export * from './lib/ngx-gallery-animation';
export * from './lib/ngx-gallery-image-size';
export * from './lib/ngx-gallery-layout';
export * from './lib/ngx-gallery-order';
export * from './lib/ngx-gallery-ordered-image';
